import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AuthProvider from "context/AuthContext";
import App from "App";
import { ToastProvider } from "context/ToastContext";

const root = ReactDOM.createRoot(document.getElementById("ptms"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </AuthProvider>
  </React.StrictMode>
);
